<template>
  <div class="Activation">
    <template v-if="nowPage == '稼動率統計'"
      ><b-container class="px-0">
        <b-row class="mx-0">
          <div
            style="width:100vw"
          >
            <b-row class="mx-0 mb-3">
              <b-col cols="1"> </b-col>

              <b-col cols="10">
                <b-col
                  cols="12"
                  class="p-0 m-0 mt-4"
                  style="font-size: 1.75rem; color: #000000"
                >
                  <span class="m-auto">稼動率統計</span>
                </b-col>

                <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                  <b-row>
                    <commonQueryIoT />
                  </b-row>
                </b-col>

                <b-col cols="12" style="margin-top: 2rem">
                  <queryResult />
                </b-col>

                <singleChart class="text-left" style="margin-top: 2rem" />

                <b-col cols="12" class="text-right">
                  <exportCsv />
                </b-col>

                <b-col
                  cols="12"
                  class="text-right mx-0 px-0"
                  style="margin-top: 0.6rem"
                >
                  <activationData class="text-left" />
                </b-col>
              </b-col>

              <b-col cols="1"> </b-col>
            </b-row>
          </div>
        </b-row> </b-container
    ></template>
    <template v-else-if="nowPage == '稼動率日誌'">
      <b-conainer class="px-0">
        <b-row class="mx-0">
          <div style="width: 100vw">
            <b-row class="mx-0 mb-3">
              <b-col cols="1"> </b-col>

              <b-col cols="10">
                <b-col
                  cols="12"
                  class="p-0 m-0 mt-4"
                  style="font-size: 1.75rem; color: #000000"
                >
                  <span class="m-auto">稼動率日誌</span>
                </b-col>

                <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                  <b-row class="mx-0 my-3">
                    <b-col cols="12" sm="12" md="12" lg="7" xl="7"
                      ><commonQueryIoT
                    /></b-col>
                    <b-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="5"
                      xl="5"
                      class="text-right align-self-end"
                    >
                      <div v-if="Object.keys(activationlog_data).length > 0">
                        <div
                          class="mt-3 ml-2"
                          style="display: inline-block; width: 170px"
                        >
                          <div
                            style="
                              display: inline-block;
                              background-color: #f2f2f2;
                              color: #00b152;
                              padding: 5px 10px 5px 10px;
                            "
                          >
                            良好
                          </div>
                          <div style="display: inline-block; width: 110px">
                            稼動率85%以上
                          </div>
                        </div>
                        <div
                          class="mt-3 ml-2"
                          style="display: inline-block; width: 170px"
                        >
                          <div
                            style="
                              display: inline-block;
                              background-color: #f2f2f2;
                              color: #ffc100;
                              padding: 5px 10px 5px 10px;
                            "
                          >
                            注意
                          </div>
                          <div style="display: inline-block; width: 110px">
                            稼動率85%以下
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mx-0 my-3">
                    <b-col
                      v-for="(item, key) in show_device_list"
                      :key="key"
                      cols="12"
                      :xl="selected_porcess == 7 ? 12 : 6"
                      lg="12"
                      md="12"
                      sm="12"
                      class="px-0 elecboard-device-col"
                    >
                      <div style="min-width: 320px">
                        <b-row
                          v-if="activationlog_data[item] != undefined"
                          class="mx-0 py-1"
                          style="
                            color: #000000;
                            font-size: 1.125rem;
                            border: 1px solid #cccccc;
                          "
                        >
                          <b-col
                            cols="3"
                            xl="2"
                            lg="2"
                            md="3"
                            sm="3"
                            class="px-3 text-center"
                            style="align-self: center"
                          >
                            <div class="mx-auto my-2">
                              <p
                                class="m-0"
                                style="
                                  background-color: #cccccc;
                                  color: #ffffff;
                                  height: 40.5px;
                                  line-height: 40.5px;
                                  overflow: hidden;
                                "
                                :style="{
                                  'background-color':
                                    activationlog_data[item]
                                      .activation_percent >= 85
                                      ? '#00b152'
                                      : activationlog_data[item]
                                          .activation_percent < 85
                                      ? '#ffc100'
                                      : '#cccccc',
                                }"
                              >
                                {{ item }}
                              </p>
                              <p
                                class="m-0"
                                style="
                                  background-color: #f2f2f2;
                                  height: 40.5px;
                                  line-height: 40.5px;
                                  overflow: hidden;
                                "
                                :style="{
                                  color:
                                    activationlog_data[item]
                                      .activation_percent >= 85
                                      ? '#00b152'
                                      : activationlog_data[item]
                                          .activation_percent < 85
                                      ? '#ffc100'
                                      : '#cccccc',
                                }"
                              >
                                <span
                                  v-if="
                                    activationlog_data[item]
                                      .activation_percent >= 85
                                  "
                                  >良好</span
                                >
                                <span
                                  v-else-if="
                                    activationlog_data[item]
                                      .activation_percent < 85
                                  "
                                  >注意</span
                                >
                                <span v-else>-</span>
                              </p>
                            </div>
                          </b-col>
                          <b-col
                            cols="9"
                            xl="10"
                            lg="10"
                            md="9"
                            sm="9"
                            class="pl-0 pr-3 my-2 text-left"
                          >
                            <b-row class="mx-0">
                              <b-col
                                cols="12"
                                class="px-0 d-flex justify-content-between"
                              >
                                <div
                                  style="
                                    overflow-x: hidden;
                                    white-space: nowrap;
                                  "
                                >
                                  <span>待機時間:</span>
                                  <span>
                                    {{
                                      activationlog_data[item].device_queue_time
                                    }}
                                  </span>
                                </div>
                                <div
                                  style="
                                    overflow-x: hidden;
                                    white-space: nowrap;
                                  "
                                  v-if="selected_porcess !== 8"
                                >
                                  <span>機型:</span>
                                  <span
                                    >{{ activationlog_data[item].device_model }}
                                  </span>
                                </div>
                                <div style="white-space: nowrap">
                                  <span>稼動率:</span>
                                  <span>
                                    {{
                                      activationlog_data[item]
                                        .activation_percent + "%"
                                    }}</span
                                  >
                                </div>
                              </b-col>
                            </b-row>

                            <b-row class="mx-0">
                              <b-col
                                cols="12"
                                class="px-0"
                                v-if="selected_porcess == 8"
                              >
                                <stackBar
                                  :stacksBarClass="stacksBarClass"
                                  :stacksBarMaxValue="43200"
                                  :stacksData="
                                    activationlog_data[item]
                                      .stack_bar_information
                                  "
                                  :stacksSize="'package-midle'"
                                />
                              </b-col>
                              <b-col cols="12" class="px-0" v-else>
                                <stackBar
                                  :stacksBarClass="stacksBarClass"
                                  :stacksBarMaxValue="stacksBarMaxValue"
                                  :stacksData="
                                    activationlog_data[item]
                                      .stack_bar_information
                                  "
                                  :stacksSize="'midle'"
                                />
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row
                          v-else
                          class="mx-0 py-1"
                          style="
                            color: #cccccc;
                            font-size: 1.125rem;
                            border: 1px solid #cccccc;
                          "
                        >
                          <b-col
                            cols="3"
                            xl="2"
                            lg="2"
                            md="2"
                            sm="3"
                            class="px-3 text-center"
                            style="align-self: center"
                          >
                            <div class="mx-auto my-2">
                              <p
                                class="m-0"
                                style="
                                  background-color: #cccccc;
                                  color: #ffffff;
                                  height: 40.5px;
                                  line-height: 40.5px;
                                "
                              >
                                {{ item }}
                              </p>
                              <p
                                class="m-0"
                                style="
                                  background-color: #f2f2f2;
                                  color: #cccccc;
                                  height: 40.5px;
                                  line-height: 40.5px;
                                "
                              >
                                -
                              </p>
                            </div>
                          </b-col>
                          <b-col
                            cols="9"
                            xl="10"
                            lg="10"
                            md="10"
                            sm="9"
                            class="pl-0 pr-3 my-2 text-left"
                          >
                            <b-row class="mx-0">
                              <b-col
                                cols="12"
                                class="px-0 d-flex justify-content-between"
                              >
                                <div
                                  style="
                                    overflow-x: hidden;
                                    white-space: nowrap;
                                  "
                                >
                                  <span>待機時間:</span>
                                  <span>-</span>
                                </div>
                                <div>
                                  <span>稼動率:</span>
                                  <span>-</span>
                                </div>
                              </b-col>
                            </b-row>
                            <b-row class="mx-0">
                              <b-col cols="12" class="px-0">
                                <stackBar
                                  :stacksBarClass="stacksBarClass"
                                  :stacksBarMaxValue="stacksBarMaxValue"
                                  :stacksData="stacksBarDefault"
                                  :stacksSize="'midle'"
                                />
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>

              <b-col cols="1"> </b-col>
            </b-row>
          </div>
        </b-row>
      </b-conainer>
    </template>
  </div>
</template>

<script>
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import queryResult from "@/components/queryResult.vue";
import singleChart from "@/components/singleChart.vue";
import exportCsv from "@/components/exportCsv.vue";
import activationData from "@/components/activationData.vue";
import stackBar from "@/components/stackBar.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Activation",
  data() {
    return {
      show_device_list: [],
      device_array: [],
      activationlog_data: {},
      stacksBarDefault: {
        "-": [
          {
            status: null,
            endTime: "2021-02-17 08:00:00",
            alarmDetail: "",
            startTime: "2021-02-17 08:00:00",
            duration_number: 0,
            stacksBarNumber: [
              "08",
              "09",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "00",
              "01",
              "02",
              "03",
              "04",
              "05",
              "06",
              "07",
              "08",
            ],
          },
        ],
      },
      selected_porcess: "",
      query_date: "",
      device_name: "",
      // chartData: {
      //   activationChart: {
      //     senTime: ["2019年12月", "2020年1月", "2020年2月", "2020年3月"],
      //     senData: {
      //       bar: {
      //         F12: {
      //           data: [82, 89, 75, 90],
      //         },
      //         F13: {
      //           data: [80, 77, 82, 84],
      //         },
      //         F14: {
      //           data: [78, 85, 90, 85],
      //         },
      //       },
      //       line: {
      //         name: "平均稼動率",
      //         data: [],
      //         color: "#000000",
      //       },
      //       unit: "%",
      //     },
      //     senType: "VerticalBarLine",
      //   },
      // },
      activationChart: {
        name: {
          chartId: "activationChart",
          chartName: "警報履歷圖表",
        },
        options: [
          {
            text: "依日統計",
            value: {
              name: "day",
              data: {
                senTime: [],
                senData: {
                  bar: {},
                  line: {
                    name: "平均稼動率",
                    data: [],
                    color: "#000000",
                  },
                  unit: "%",
                },
                senType: "VerticalBarLine",
              },
            },
          },
          {
            text: "依周統計",
            value: {
              name: "week",
              data: {
                senTime: [],
                senData: {
                  bar: {},
                  line: {
                    name: "平均稼動率",
                    data: [],
                    color: "#000000",
                  },
                  unit: "%",
                },
                senType: "VerticalBarLine",
              },
            },
          },
          {
            text: "依月統計",
            value: {
              name: "month",
              data: {
                senTime: [],
                senData: {
                  bar: {},
                  line: {
                    name: "平均稼動率",
                    data: [],
                    color: "#000000",
                  },
                  unit: "%",
                },
                senType: "VerticalBarLine",
              },
            },
          },
        ],
      },
      nowPage: "",
      window_innerWidth: "",
      return_select_option: false,
    };
  },
  created: function () {
    window.addEventListener("beforeunload", this.setSessionItems);
    let page = sessionStorage.getItem("activation_page");
    if (page == "稼動率日誌") {
      this.set_sideBarSelect(["activation", "activationlog"]);
    } else if (page == "稼動率統計") {
      this.set_sideBarSelect(["activation", "activationstatistics"]);
    } else {
      this.set_sideBarSelect(["activation", "activationlog"]);
    }

    sessionStorage.removeItem("activation_page");
    this.change_selectPage("activation");

    this.change_selectPageName(this.pageName.activation);
    this.setCommonQueryData();
    this.setQueryInput();
    // this.getSelectOption();
    this.set_singleChartName(this.activationChart.name);
    this.set_singleChartSelected(this.activationChart.options[0].value);
    this.set_singleChartOptions(this.activationChart.options);
    this.set_activationDataItem([]);
    window.addEventListener("resize", this._onResize_activation);
  },
  mounted: function () {
    let vm = this;
    vm.resetExportCsv();
    vm.setExportDataTitle();
  },
  components: {
    commonQueryIoT,
    queryResult,
    singleChart,
    exportCsv,
    activationData,
    stackBar,
  },
  watch: {
    sideBarSelect: {
      handler() {
        let vm = this;
        vm.nowPage = vm.sideBarSelect.processName;
        console.log(vm.sideBarSelect);
        vm.setQueryInput();
        vm.setCommonQueryData();
        if (vm.return_select_option) {
          vm.PackageOption();
        }
      },
    },
    mainQueryResponse: {
      handler() {
        let vm = this;
        if (vm.nowPage == "稼動率日誌") {
          vm.reset([]);
          if (
            vm.mainQueryResponse == "查無資料" ||
            vm.mainQueryResponse == "時間尚未選擇"
          ) {
            vm.set_sideBarSelect(["activation", "activationlog"]);
            return;
          }
          vm.set_sideBarSelect(["activation", "activationlog"]);
          vm.device_array = vm.mainQueryResponse[0].device_array;
          vm.activationlog_data = vm.mainQueryResponse[0].stack_bar_information;
          vm.selected_porcess = vm.mainQueryResponse[0].process;
          vm._onResize_activation();
        } else if (vm.nowPage == "稼動率統計") {
          vm.reset([]);
          if (
            vm.mainQueryResponse == "查無資料" ||
            vm.mainQueryResponse == "時間尚未選擇"
          ) {
            vm.set_sideBarSelect(["activation", "activationstatistics"]);
            return;
          }
          vm.set_sideBarSelect(["activation", "activationstatistics"]);
          var itemsArray = [];
          var devicearray = [];
          if (vm.mainQueryResponse[0].device_detail_data.length > 0) {
            for (
              var i = 0;
              i < vm.mainQueryResponse[0].device_detail_data.length;
              i++
            ) {
              var itemsObj = {};
              // itemsObj["classItem"] =
              //   vm.mainQueryResponse[0].device_detail_data[i]["class"];
              itemsObj["date"] =
                vm.mainQueryResponse[0].device_detail_data[i]["date"];
              itemsObj["activation"] =
                vm.mainQueryResponse[0].device_detail_data[i]["activation"];
              // itemsObj["device"] =
              //   vm.mainQueryResponse[0].device_detail_data[i]["device_name"];
              // itemsObj["groupItem"] =
              //   vm.mainQueryResponse[0].device_detail_data[i]["group"];
              // itemsObj["placeItem"] =
              //   vm.mainQueryResponse[0].device_detail_data[i]["site"];
              itemsArray.push(itemsObj);
            }
          }
          console.log(itemsArray);
          vm.activationChart.options[0].value.data.senTime =
            vm.mainQueryResponse[0].device_data_day.data_time;
          vm.activationChart.options[0].value.data.senData.bar =
            vm.mainQueryResponse[0].device_data_day.data;

          vm.activationChart.options[1].value.data.senTime =
            vm.mainQueryResponse[0].device_data_week.data_time;
          vm.activationChart.options[1].value.data.senData.bar =
            vm.mainQueryResponse[0].device_data_week.data;

          vm.activationChart.options[2].value.data.senTime =
            vm.mainQueryResponse[0].device_data_month.data_time;
          vm.activationChart.options[2].value.data.senData.bar =
            vm.mainQueryResponse[0].device_data_month.data;
          // vm.activationChart.options[2].value.data.senTime =
          //   vm.mainQueryResponse[0].device_data_year.data_time;
          // vm.activationChart.options[2].value.data.senData.bar =
          //   vm.mainQueryResponse[0].device_data_year.data;

          vm.activationChart.selected = vm.activationChart.options[0].value;
          // vm.set_singleChartSelected(vm.activationChart.options[0].value);
          // vm.set_singleChartOptions(vm.activationChart.options);
          vm.query_date =
            vm.mainQueryResponse[0].query_date[0].split(" ")[0] +
            "~" +
            vm.mainQueryResponse[0].query_date[1].split(" ")[0];

          vm.set_queryResultItem([
            {
              date: vm.query_date,
              site: vm.mainQueryResponse[0].query_date[2],
              process: vm.mainQueryResponse[0].query_date[3],
              group: vm.mainQueryResponse[0].query_date[4],
              device: vm.mainQueryResponse[0].query_date[5],
            },
          ]);
          vm.set_singleChartName(vm.activationChart.name);
          vm.set_singleChartSelected(vm.activationChart.options[0].value);
          vm.set_singleChartOptions(vm.activationChart.options);
          vm.set_activationDataItem(itemsArray);
          vm.set_exportData(itemsArray);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      activationDataFields: "activationData/get_activationDataFields",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
      stacksBarClass: "stackBar/get_stacksBarClass",
      stacksBarMaxValue: "stackBar/get_stacksBarMaxValue",
      processOption: "commonqueryiot/get_processOption",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_processOption: "commonqueryiot/set_processOption",
      set_actProcessOption: "commonqueryiot/set_actProcessOption",
      set_deviceOption: "commonqueryiot/set_deviceOption",
      set_groupOption: "commonqueryiot/set_groupOption",
      set_queryResultItem: "queryResult/set_queryResultItem",
      clear_queryResultItem: "queryResult/clear_queryResultItem",
      set_singleChartSelected: "singleChart/set_singleChartSelected",
      set_singleChartOptions: "singleChart/set_singleChartOptions",
      set_singleChartName: "singleChart/set_singleChartName",
      clear_singleChart: "singleChart/clear_singleChart",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
      set_activationDataItem: "activationData/set_activationDataItem",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect",
    }),
    setCommonQueryData() {
      let vm = this;
      if (vm.nowPage == "稼動率日誌") {
        vm.set_phpfunction("Get_activation_log");
      } else if (vm.nowPage == "稼動率統計") {
        vm.set_phpfunction("MainQuery");
      }
    },
    setQueryInput() {
      let vm = this;
      if (vm.nowPage == "稼動率日誌") {
        vm.set_selectTag({
          startTime: true,
          endTime: false,
          process: false,
          actProcess: true,
          deviceCode: false,
          productCode: false,
          workCode: false,
          group: true,
        });
        vm.set_selectTagCheck({
          startTime: true,
          endTime: false,
          process: false,
          actProcess: true,
          deviceCode: false,
          productCode: false,
          workCode: false,
          group: true,
        });
      } else if (vm.nowPage == "稼動率統計") {
        vm.set_selectTag({
          startTime: true,
          endTime: true,
          process: true,
          actProcess: false,
          deviceCode: true,
          productCode: false,
          workCode: false,
          group: false,
        });
        vm.set_selectTagCheck({
          startTime: true,
          endTime: true,
          process: true,
          actProcess: false,
          deviceCode: true,
          productCode: false,
          workCode: false,
          group: false,
        });
      }
    },
    getSelectOption() {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      console.log(params);
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.set_processOption(result.QueryTableData.process);
          vm.set_actProcessOption(result.QueryTableData.actProcess);
          vm.set_groupOption(result.QueryTableData.group);
          vm.set_deviceOption(result.QueryTableData.device);
          vm.return_select_option = true;
          vm.PackageOption();
        }
      });
    },
    PackageOption() {
      //增加包裝選項
      let vm = this;
      let addPackageOption = vm.processOption;
      if (vm.nowPage == "稼動率日誌") {
        let existOption = false;
        addPackageOption.forEach((item) => {
          if (item.value == 8) {
            existOption = true;
          }
        });
        if (!existOption) {
          addPackageOption.push({
            text: "包裝",
            value: 8,
          });
          vm.set_processOption(addPackageOption);
        }
      } else if (vm.nowPage == "稼動率統計") {
        let noPackageOption = [];
        addPackageOption.forEach((item) => {
          if (item.value !== 8) {
            noPackageOption.push(item);
          }
        });
        vm.set_processOption(noPackageOption);
      }
    },
    _onResize_activation() {
      let vm = this;
      vm.window_innerWidth = window.innerWidth;
      vm._onResize_activation_detail_list();
    },
    _onResize_activation_detail_list() {
      let vm = this;
      let show_device_list = [];
      if (vm.selected_porcess == "7") {
        show_device_list = vm.device_array;
        vm.show_device_list = show_device_list;
        return;
      }
      if (vm.window_innerWidth > 1200) {
        let divisor = Math.round(vm.device_array.length / 2);
        vm.device_array.forEach((data, index) => {
          if (index < divisor) {
            show_device_list[index * 2] = data;
          } else {
            show_device_list[(index - divisor) * 2 + 1] = data;
          }
        });
      } else {
        show_device_list = vm.device_array;
      }
      vm.show_device_list = show_device_list;
    },
    resetExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },
    setExportDataTitle() {
      let vm = this;
      let exportDataTitle = [];
      vm.activationDataFields.forEach((data) => {
        exportDataTitle.push(data.label);
      });
      vm.set_exportDataTitle(exportDataTitle);
    },
    setSessionItems() {
      sessionStorage.setItem("activation_page", this.sideBarSelect.processName);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  destroyed() {
    // this.clear_singleChart();
    this.clear_queryResultItem();
    window.removeEventListener("beforeunload", this.setSessionItems);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/views/Activation.vue